import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronTransparent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 8,
	viewBox: "0 0 15 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0918 7L7.0918 1L1.0918 7",
		stroke: "current",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronTransparent;
